import DoorLockSettings from 'localization/base/pages/DoorLockSettings';

const doorLockSettings: DoorLockSettings = {
  header: 'Türverriegelung',
  mainDoors: 'Haupteingang'
};

export default doorLockSettings;
